import { ref } from "vue";
import { getRoleTree } from "@/services";
import { generateError } from "@/shared/utils";

export default function setup() {
  const getRoleLoading = ref(false);
  const roles = ref([]);
  const getRoleTreeData = async () => {
    try {
      getRoleLoading.value = true;
      const response = await getRoleTree();
      roles.value = [...response];
    } catch (error) {
      generateError(error);
    } finally {
      getRoleLoading.value = false;
    }
  };
  getRoleTreeData();

  return { getRoleLoading, roles };
}
